import { Box, Button, InputAdornment, OutlinedInput, Typography } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import { dialogContent, closeBtn, dialogTitle, paperProps } from 'app/components/AsanConfirmation/AsanConfirmation.sx';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from 'app/components/Icons/CloseIcon';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import AsanImza from 'app/components/AsanImzaComponent/AsanImza';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  verifyCode?: any;
  timerTime?: any;
  pathUrl?: any;
  businessKey?: any;
}
const AsanConfirmation = (props: Props) => {
  const { open, close, verifyCode, timerTime, pathUrl, businessKey } = props;

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: paperProps,
      }}
      onClose={() => close(false)}
    >
      <DialogTitle sx={dialogTitle}>
        <Typography sx={{ fontSize: '26px', fontWeight: 600 }}>Asan İmza ilə təsdiq</Typography>
        {/*<Button*/}
        {/*  color={'tertiary'}*/}
        {/*  onClick={() => {*/}
        {/*    close(false);*/}
        {/*  }}*/}
        {/*  sx={closeBtn}*/}
        {/*>*/}
        {/*  <CloseIcon />*/}
        {/*</Button>*/}
      </DialogTitle>
      <DialogContent sx={dialogContent}>
        <AsanImza
          btnSx={{ marginTop: '62px' }}
          asanModalType={'transfer'}
          verifyCode={verifyCode}
          close={close}
          timerTime={timerTime}
          pathUrl={pathUrl}
          businessKey={businessKey}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AsanConfirmation;
